import React from "react";

import { Section } from "@origin-digital/ods-core";

import { cloudinary } from "src/consts";

import { Benefits, Benefit } from "../../components/Benefits";

import content from "./content.json";
import assets from "./assets.json";

export interface IImageProps {
  src: string;
  alt: string;
}

const Image: React.FC<IImageProps> = ({ src, alt }) => (
  <img src={cloudinary + src} alt={alt} width="100%" />
);

export const BenefitSection: React.FC = () => (
  <Section>
    <Benefits heading={content.heading}>
      {content.benefits.map(({ heading, text, image, cta }, idx) => (
        <Benefit
          key={idx}
          heading={heading}
          text={text}
          reverse={idx % 2 !== 0}
          cta={cta}
        >
          <Image {...assets[image]} />
        </Benefit>
      ))}
    </Benefits>
  </Section>
);
